import {all, call, put, takeEvery} from 'redux-saga/effects';
import * as constants from '../constants';
import * as api from '../services/api';
import {logout} from '../actions/authActions';

function* set({payload}) {
    try {
        yield call(api.request, payload.nodeId, payload.propId, payload.value);
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
    }
}

export default function* root() {
    yield all([
        takeEvery(constants.PROPERTY_VALUE_REQUEST, set),
    ]);
}
